import { useMutation, UseMutationResult } from 'react-query';
import { DocketCaseDocument } from '../../models/CompanyDockets';
import { ApiError } from '../../services/api-error.model';
import { downloadDocketItem } from '../../services/dockets/dockets.service';
import { DownloadItemResponse } from '../../services/dtos/companyDockets/dockets.dto';
import { CaseDocumentsQueryFilters } from './useFetchCaseDocuments';

export interface UseInitiateDownloadDocketDocumentPayload {
  docketCaseDocument: DocketCaseDocument;
  page: number;
  pageSize: number;
  filters: CaseDocumentsQueryFilters;
}

export default (): UseMutationResult<
  DownloadItemResponse,
  ApiError,
  UseInitiateDownloadDocketDocumentPayload,
  void
> => {
  return useMutation(async ({ docketCaseDocument }: UseInitiateDownloadDocketDocumentPayload) =>
    downloadDocketItem(docketCaseDocument.docketItemCaseId, docketCaseDocument.docketItemId)
  );
};
